import { EditorialPanel, EditorialProcessBlock, EditorialStatsBlock } from "../editorial";

/**
 * Detalles · paso 3 · Por qué creerlo.
 *
 * El proceso —cómo se hace, paso a paso— y las cifras que se leen de
 * lejos. Son los dos bloques que sostienen lo que promete la parte de
 * arriba: uno cuenta el trabajo y el otro lo mide.
 *
 * Son solo dos y no tres a propósito. El reparto de estos cuatro pasos
 * no es por cantidad de bloques sino por lo que se está contando; forzar
 * un tercero aquí obligaría a robárselo a la composición o al cierre, y
 * cada uno de esos pasos dejaría de leerse entero.
 */
export function BackingStep() {
  return (
    <EditorialPanel
      title="Respaldo"
      description="Cómo se hace y qué números lo sostienen. Ninguno es obligatorio."
    >
      {(locale) => (
        <>
          <EditorialProcessBlock locale={locale} />
          <EditorialStatsBlock locale={locale} />
        </>
      )}
    </EditorialPanel>
  );
}
